import { defineStore } from 'pinia';
export const useHistoryStore = defineStore('mediaHistory', {
    state: () => {
        return {
            history: [],
            historyIndex: -1,
        };
    },
    actions: {
        setHistory(id, source, before, after, type) {
            if (this.historyIndex !== this.history.length - 1) {
                this.history.splice(this.historyIndex + 1);
            }
            this.history.push({
                id,
                source,
                before,
                after,
                type,
            });
            this.historyIndex = this.history.length - 1;
        },
        undo() {
            if (this.historyIndex !== -1) {
                const history = this.history[this.historyIndex];
                this.historyIndex -= 1;
                return history;
            }
            return {};
        },
        redo() {
            if (this.historyIndex !== this.history.length - 1) {
                this.historyIndex += 1;
                return this.history[this.historyIndex];
            }
            return {};
        },
        reset() {
            this.history = [];
            this.historyIndex = -1;
        },
    },
});
